import { SetTeamTypeRequest } from '@cbinsights/userv2service/userv2service';
import { request } from 'client/modules/common/utils/request';

export const setTeamType = (req: Partial<SetTeamTypeRequest>): Promise<void> =>
  request({
    url: '/service/userv2service/SetTeamType',
    body: req,
  }).then((r) => r.body);
